import './style.less';
import uuid from 'uuid';

export default function() {
  const vm = this;
  vm.$onInit = activate;

  function activate() {
    if (vm.ngModel) vm.uuids = vm.ngModel.map(model => uuid.v4());
  }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/multiAnswer/view/controller.js